import { render, staticRenderFns } from "./pinned-message.vue?vue&type=template&id=1be21db4&scoped=true&"
import script from "./pinned-message.vue?vue&type=script&lang=js&"
export * from "./pinned-message.vue?vue&type=script&lang=js&"
import style0 from "./pinned-message.vue?vue&type=style&index=0&id=1be21db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be21db4",
  null
  
)

export default component.exports